// System, VCOMSAT, and AI Model Types

export interface Customer {
  id: number;
  name: string;
  phone: string;
  email?: string;
  address?: string;
  companyName?: string;
  notes?: string;
  createdAt: string;
  updatedAt: string;
  createdByUserId: string;
  createdByUserName: string;
}

export interface CreateCustomer {
  name: string;
  phone: string;
  email?: string;
  address?: string;
  companyName?: string;
  notes?: string;
}

export enum ModelPurpose {
  DocumentTypeDetection = 1,
  DocumentProcessing = 2,
  DocumentProcessingPdf = 3,
  DocumentProcessingImage = 4,
  TelegramChat = 5
}

export interface AiModel {
  id: number;
  name: string;
  description?: string;
  isSelected: boolean;
  purpose: ModelPurpose;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAiModel {
  name: string;
  description?: string;
  purpose: ModelPurpose;
}

export interface UpdateAiModel {
  name: string;
  description?: string;
  purpose: ModelPurpose;
}

export interface SelectAiModel {
  id: number;
}

export interface VcomsatSyncResult {
  success: boolean;
  totalVcomsatVehicles: number;
  syncedCount: number;
  matchedCount: number;
  message: string;
  syncedVehicles: VcomsatSyncDetail[];
}

export interface VcomsatSyncDetail {
  vcomsatCarID: number;
  carPlate: string;
  carTypeName: string;
  matched: boolean;
  vehicleId?: number;
}

export interface VcomsatCarDetail {
  id: number;
  vcomsatCarID: number;
  carPlate: string;
  carTypeName: string;
  groupName: string;
  vehicleId?: number;
  vehicleLicensePlate?: string;
  syncedAt: string;
  updatedAt: string;
}

export interface VcomsatJourneySyncResult {
  success: boolean;
  vcomsatCarID: number;
  carPlate: string;
  fromDate: string;
  toDate: string;
  totalJourneyDetails: number;
  syncedJourneyDetails: number;
  totalKm: number;
  runningTime: string;
  stopCount: number;
  message: string;
}

export interface VcomsatJourneyDetail {
  id: number;
  realTime: string;
  status: number;
  speed: number;
  latitude: number;
  longitude: number;
  durationSeconds: number;
  address: string;
  distanceKm: number;
  syncedAt: string;
}
